import { atom } from 'jotai';
import { $PageLevelTraffic, $UserDetailV2 } from 'shared/atoms';
import { EPageType, IUserDetail, IUserPageTraffic, UserDetailUtil } from 'shared/models';
import { pendingQueue } from 'shared/utils/pending-queue';

export const CurrentUserId = atom((get) => {
  const traffic = get($PageLevelTraffic);
  const { pageType } = traffic;

  if (![EPageType.user, EPageType.user_follow, EPageType.user_topic].includes(pageType)) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Promise((resolve) => pendingQueue.push(resolve));
  }

  const userTraffic = traffic as IUserPageTraffic;

  return userTraffic.userId || null;
});

export const $CurrentUserLinkName = atom((get) => {
  const traffic = get($PageLevelTraffic);
  const { pageType } = traffic;

  if (![EPageType.user, EPageType.user_follow, EPageType.user_topic].includes(pageType)) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw new Promise((resolve) => pendingQueue.push(resolve));
  }

  const userTraffic = traffic as IUserPageTraffic;

  return userTraffic.userLinkName;
});

export const $CurrentUser = atom((get) => {
  const currentUserLinkName = get($CurrentUserLinkName);
  return get($UserDetailV2(currentUserLinkName));
});

export const $CurrentAvailableUserOrNull = atom(async (get) => {
  const user = await get($CurrentUser);
  return UserDetailUtil.isUserAvailable(user) ? user : null;
});

export const $CurrentUserAsAvailable = atom(async (get) => {
  const user = await get($CurrentUser);
  return user as IUserDetail;
});
